import React from "react";
import { get } from "lodash";
import styled from "styled-components";
import StoryContent from "components/pages/article/StoryContent";
import { baseUrl } from "services/shared/Environment";
import withApollo from "components/higher-order/withApollo";
import { StoryMetaTags } from "components/shared/MetaTags/MetaTags";
import PageContainer from "components/containers/PageContainer";
import { FooterWithState } from "components/Footer";
import { useRecordPageView } from "hooks/analytics/useRecordPageView";
import { ArticlePageContextProvider } from "contexts/new/ArticlePageContext";
import { useUserContext } from "contexts/new/UserContext";
import verifyGooglebot from "libraries/verify-googlebot/verify";
import StoryBodyHtml from "components/pages/article/StoryBodyHtml";
import ApiStory from "models/data/api/ApiStory";
import ApiTextEssay from "models/data/api/ApiTextEssay";
import { getStoryBySlug } from "services/server/api/ApiStory";
import { isEmpty } from "lodash";
import { request, gql } from "graphql-request";

const storyMetaTagsQuery = gql`
  query storyMetaTagsQuery($storySlug: String!) {
    story(storySlug: $storySlug) {
      id
      slug
      title
      publicationDate
      summary
      author {
        id
        fullName
      }
      featuredImage {
        id
        url
      }
    }
  }
`;

const StoryPageContainer = styled.div`
  min-height: calc(100vh - 64px);
`;

interface Props {
  storySlug: string;
  sharedStoryLinkId: string;
  storyUrl: string;
  story;
  metatagStory: any;
}
function Story({
  storySlug,
  sharedStoryLinkId,
  storyUrl,
  story,
  metatagStory,
}: Props) {
  useRecordPageView();

  const userContext = useUserContext();

  return (
    <ArticlePageContextProvider>
      <StoryMetaTags storyUrl={storyUrl} story={metatagStory} />
      <PageContainer>
        <StoryPageContainer>
          {userContext.initialized && (
            <StoryContent
              storySlug={storySlug}
              sharedStoryLinkId={sharedStoryLinkId}
            />
          )}
          {!isEmpty(story) && <GoogleBotContent story={story} />}
        </StoryPageContainer>
        <FooterWithState />
      </PageContainer>
    </ArticlePageContextProvider>
  );
}

const GoogleBotContent = ({ story }) => {
  const body = ApiTextEssay.bodyHtml(ApiStory.textEssay(story));
  return (
    <div className=".paywall-content" style={{ display: "none" }}>
      <StoryBodyHtml html={body} />
    </div>
  );
};

Story.getInitialProps = async function ({ asPath, req, ...props }) {
  const storySlug = get(props.query, "slug", "");
  let story = {};
  if (verifyGooglebot) {
    try {
      const ip = req.headers["x-forwarded-for"] || req.connection.remoteAddress;
      const isGoogle = await verifyGooglebot(ip);
      if (isGoogle) {
        story = await getStoryBySlug(storySlug);
      }
    } catch (e) {
      console.log(e);
    }
  }

  let res: any = {};
  try {
    res = await request(`${baseUrl()}/api/graphql`, storyMetaTagsQuery, {
      storySlug,
    });
  } catch (e) {
    console.log(e);
  }

  const initialProps = {
    storySlug: storySlug,
    sharedStoryLinkId: get(props.query, "s", ""),
    storyUrl: `https://www.thejuggernaut.com${asPath}`,
    story: story,
    metatagStory: res?.story ?? {},
  };
  return initialProps;
};

export default withApollo(Story);
